<div
  class="modal fade"
  #shareModal
  id="shareModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="shareModal"
  aria-hidden="true"
  [attr.data-backdrop]="backdrop"
  [attr.data-keyboard]="keyboard"
>
  <div
    class="modal-dialog modal-dialog-custom modal-dialog-centered"
    role="document"
  >
    <div class="modal-content">
      <div class="modal-header py-3 px-4">
        <h5 class="modal-title fw-700">Share</h5>
        <button
          type="button"
          class="close modal-close-button font-32 mt-2"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true"
            ><app-icon
              name="x"
              class="cx-icon--sm"
              aria-hidden="true"
            ></app-icon
          ></span>
        </button>
      </div>
      <div class="modal-body modal-confirm mt-2">
        <fieldset *ngIf="shareDestinations.length" class="share-destinations">
          <legend>Choose what to share</legend>
          <label
            *ngFor="let destination of shareDestinations"
            class="share-destination"
            [class.share-destination--selected]="
              selectedDestinationId === destination.id
            "
          >
            <input
              type="radio"
              name="share-destination"
              [value]="destination.id"
              [checked]="selectedDestinationId === destination.id"
              (change)="selectDestination(destination)"
            />
            <span>
              <strong>
                {{ destination.label }}
                <span
                  *ngIf="destination.recommended"
                  class="share-destination__recommended"
                >
                  Recommended
                </span>
              </strong>
              <small>{{ destination.description }}</small>
            </span>
          </label>
        </fieldset>
        <div class="text-center mb-3">
          <share-buttons
            [theme]="'modern-light'"
            [include]="[
              'facebook',
              'twitter',
              'linkedin',
              'reddit',
              'whatsapp',
              'sms',
              'email'
            ]"
            [url]="activeShareUrl || currentUrl"
            [showText]="false"
            (opened)="onShareOpened()"
          ></share-buttons>
        </div>
        <div class="input-group col-12 copy-input-group px-0">
          <input
            type="text"
            class="form-control"
            [value]="activeShareUrl || currentUrl"
            #copyLink
            readonly
          />
          <div class="input-group-prepend">
            <div class="input-group-text">
              <button
                value="click to copy"
                class="btn btn-black"
                (click)="copyToClipboard(copyLink)"
              >
                Copy
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
